/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingCommitmentRequest {
    getFixupPrototypeFunction() { return BillingCommitmentRequest.fixupPrototype; }

    static newInstance(model: Partial<BillingCommitmentRequest>): BillingCommitmentRequest {
        let obj = Object.assign(new BillingCommitmentRequest(), model);
        BillingCommitmentRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingCommitmentRequest>): BillingCommitmentRequest {
        if (!model) return null;
        return BillingCommitmentRequest.newInstance(<BillingCommitmentRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingCommitmentRequest) {
        if (!obj) return;

        models.BillingCommitmentRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingCommitmentRequest): boolean {
        Object.setPrototypeOf(obj, BillingCommitmentRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    service_account_ids: Array<string>;

}
